import { ArrowRight } from 'lucide-react';
import type { UpcomingEvent } from '../../../data/events';

export function EventCard({ event }: { event: UpcomingEvent }) {
  return (
    <article className="flex h-full flex-col overflow-hidden rounded-md border border-line bg-card">
      <div className="relative aspect-video overflow-hidden bg-subtle">
        <img
          src={event.image}
          alt={`${event.name} 2026`}
          className="h-full w-full object-cover transition-transform duration-500 hover:scale-[1.015]"
          loading="lazy"
          width="1530"
          height="600"
        />
        <span className="absolute left-4 top-4 rounded-sm bg-white/95 px-2.5 py-1 font-ui text-xs font-semibold uppercase tracking-[0.08em] text-fg-secondary">
          {event.category}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-card">
        <h3 className="font-display text-[1.7rem] font-bold leading-[1.15] text-fg-primary">{event.name}</h3>
        <p className="mt-3 font-ui text-[0.95rem] font-semibold text-fg-secondary">{event.date}</p>
        <p className="mt-1 font-body text-sm text-fg-muted">{event.venue}</p>

        <div className="mt-auto pt-7">
          <a
            href={event.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center justify-center gap-2 rounded-sm bg-action py-3 font-ui text-sm font-semibold text-action-foreground transition-colors hover:bg-action-hover"
          >
            {event.ctaLabel}
            <ArrowRight
              size={16}
              strokeWidth={2}
              className="transition-transform group-hover:translate-x-0.5"
              aria-hidden="true"
            />
          </a>
        </div>
      </div>
    </article>
  );
}

